//TableColumn

import React from 'react';
import { ExpansionList, ExpansionPanel, TableColumn } from 'react-md';
import '../css/CollapsableColumn.css';

const CollapsableColumn = function(props) {
  let columnData = props.data[0];
  let WidthReduce = props.WidthReduce
  if (props.data.length > 1) {
    let dataArray = props.data.slice(1, props.data.length);
    columnData = (
      <ExpansionList className="sectionExpansionList" style={{width: WidthReduce ? (window.innerWidth/8) * 2 : ''}} >
        <ExpansionPanel
          className=" no-shadow no-list-style sectionNameList primary-text-color"
          label={props.data[0]}
          footer={null}
        >
          {dataArray.map((rowData, index) => (
            <p className="primary-text-color" key={rowData}>
              {rowData}
            </p>
          ))}
        </ExpansionPanel>
      </ExpansionList>
    );
  }

  return <TableColumn className={props.className}  style={{width: WidthReduce ? (window.innerWidth/8) * 2 : ''}}  >{columnData}</TableColumn>;
};

export default CollapsableColumn;
